/**
 * 浏览器钱包注入探测：EIP-6963 + 晚注入监听
 * 解决 MetaMask 与 TokenPocket 等同页共存时，window.ethereum 被抢占导致误报「未安装」。
 */

const EIP6963_ANNOUNCE = 'eip6963:announceProvider'
const EIP6963_REQUEST = 'eip6963:requestProvider'

/** @type {Map<string, { rdns: string, name: string, provider: object }>} */
const byRdns = new Map()
/** @type {Set<(reason: string) => void>} */
const subscribers = new Set()
let inited = false

/** 常见钱包 EIP-6963 rdns（按优先级） */
export const WALLET_EIP6963_RDNS = {
  metamask: ['io.metamask'],
  tokenPocket: ['pro.tokenpocket', 'com.tokenpocket'],
  bitget: ['com.bitget.web3', 'com.bitkeep.wallet'],
  okx: ['com.okex.wallet', 'com.okx.wallet'],
  trust: ['com.trustwallet.app'],
  coinbase: ['com.coinbase.wallet'],
  binance: ['com.binance.wallet'],
  ave: ['ai.ave.wallet', 'com.ave.wallet'],
}

function sleepMs(ms) {
  return new Promise((r) => setTimeout(r, ms))
}

function onAnnounce(event) {
  const detail = event?.detail
  const info = detail?.info
  const provider = detail?.provider
  if (!info?.rdns || !provider || typeof provider.request !== 'function') return
  const prev = byRdns.get(info.rdns)
  if (prev?.provider === provider) return
  byRdns.set(info.rdns, {
    rdns: String(info.rdns),
    name: String(info.name || ''),
    provider,
  })
  notify('eip6963')
}

function notify(reason) {
  subscribers.forEach((fn) => {
    try {
      fn(reason)
    } catch (_e) {
      void _e
    }
  })
}

export function initInjectProbe() {
  if (inited || typeof window === 'undefined') return
  inited = true
  window.addEventListener(EIP6963_ANNOUNCE, onAnnounce)
  requestInjectProbeRefresh()
}

export function requestInjectProbeRefresh() {
  if (typeof window === 'undefined') return
  initInjectProbe()
  try {
    window.dispatchEvent(new Event(EIP6963_REQUEST))
  } catch (_e) {
    void _e
  }
}

export function subscribeInjectProbe(fn) {
  initInjectProbe()
  subscribers.add(fn)
  return () => subscribers.delete(fn)
}

export function getEip6963Entries() {
  initInjectProbe()
  return [...byRdns.values()]
}

export function getEip6963ProviderByRdns(rdns) {
  initInjectProbe()
  return byRdns.get(String(rdns || ''))?.provider || null
}

export function pickEip6963ProviderForWallet(walletKey) {
  initInjectProbe()
  const key = String(walletKey || '')
  const rdnsList = WALLET_EIP6963_RDNS[key] || []
  for (const rdns of rdnsList) {
    const p = byRdns.get(rdns)?.provider
    if (p) return p
  }
  return null
}

/** 打开连接面板 / 探测前短暂等待 6963 公告 */
export async function waitForInjectProbe({ timeoutMs = 900, intervalMs = 90 } = {}) {
  if (typeof window === 'undefined') return
  initInjectProbe()
  const deadline = Date.now() + timeoutMs
  let lastCount = byRdns.size
  while (Date.now() < deadline) {
    requestInjectProbeRefresh()
    await sleepMs(intervalMs)
    if (byRdns.size > lastCount) break
    lastCount = byRdns.size
  }
}
